module.exports = "pegasus_template/assets/three-column-image-text-preview.png";